export default function enumToLabelValue(
  source: Record<string, string>,
  mapToLabel: Record<string, string>,
): { label: string; value: string }[] {
  return Object.keys(source).map((value) => ({
    label: mapToLabel[value],
    value,
  }));
}
